// Carrinho fixo na lateral direita do BALCÃO (pedido do dono, 29/09/2026: "coloca
// o carrinho na lateral direita"). Sempre visível: o atendente vê cada item
// entrar (clique ou leitor) sem abrir gaveta. Só a lista rola; total e
// Finalizar ficam sempre à vista. O Totem continua com a gaveta (CarrinhoSheet).
// Desde 29/09/2026 o Finalizar vai direto para "Como deseja consumir?" (a tela de
// conferência saiu do Balcão): o aviso de ofertas do cliente fica no alto da
// lista e as sugestões (se a campanha estiver ligada) logo acima do Total.
// No celular (abaixo de 768 px, 25/10/2026) a lateral some — esmagava o cardápio
// — e no lugar fica a BarraPedidoCelular no rodapé; tocar nela abre este mesmo
// carrinho em tela cheia (prop `celular`), com X para voltar ao cardápio.
import { ChevronUp, ScanBarcode, ShoppingCart, X } from "lucide-react";

import { AvisoOfertasCliente } from "../../ofertas-do-dia";
import DescontoCarrinho from "./DescontoCarrinho";
import ItemCarrinho from "./ItemCarrinho";
import SugestoesLateral from "./SugestoesLateral";
import TeclaAtalho from "./TeclaAtalho";
import { fmt } from "../lib/helpers";

/** Rodapé do cardápio no celular: quantos itens, o total e o toque que abre o carrinho. */
export function BarraPedidoCelular({ ctx, onAbrir }) {
  const { cartCount, cartTotal, desconto } = ctx;
  const total = Math.max(0, cartTotal - (desconto?.montante || 0));
  return (
    <button type="button" onClick={onAbrir} data-e2e="barra-pedido-celular"
      className="md:hidden shrink-0 flex items-center gap-3 px-4 py-3 bg-zinc-900 border-t border-zinc-800 text-left active:bg-zinc-800">
      <ShoppingCart className="w-5 h-5 text-orange-500 shrink-0" />
      <span className="text-zinc-100 font-bold">Pedido</span>
      {cartCount > 0 && <span className="text-xs font-bold bg-orange-500 text-white rounded-full px-2 py-0.5">{cartCount}</span>}
      <span className="ml-auto text-lg font-black text-orange-500">R$ {fmt(total)}</span>
      <ChevronUp className="w-5 h-5 text-zinc-400 shrink-0" />
    </button>
  );
}

export default function CarrinhoLateral({ ctx, celular = false, onFechar }) {
  const { cart, cartCount, cartTotal, setScreen, ofertasCliente, desconto } = ctx;
  const vazio = cart.length === 0;
  const montante = desconto?.montante || 0;
  const caixa = celular
    ? "absolute inset-0 z-30 md:hidden flex flex-col bg-zinc-900"
    : "w-80 xl:w-96 shrink-0 min-h-0 max-md:hidden flex flex-col bg-zinc-900 border-l border-zinc-800";
  return (
    <aside className={caixa} data-e2e={celular ? "carrinho-celular" : "carrinho-lateral"}>
      <header className="px-4 h-14 shrink-0 flex items-center border-b border-zinc-800">
        <h2 className="flex items-center gap-2 text-zinc-100 font-bold">
          <ShoppingCart className="w-5 h-5 text-orange-500" /> Pedido
          {!vazio && <span className="text-xs font-bold bg-orange-500 text-white rounded-full px-2 py-0.5">{cartCount}</span>}
        </h2>
        {!vazio && !celular && <span className="ml-auto text-[11px] text-zinc-500 flex items-center gap-1.5" data-e2e="dica-esc-cancela"><TeclaAtalho>Esc</TeclaAtalho> cancela</span>}
        {celular && (
          <button type="button" onClick={onFechar} aria-label="Voltar ao cardápio" data-e2e="carrinho-celular-fechar"
            className="ml-auto p-2 -mr-2 text-zinc-400 hover:text-zinc-100">
            <X className="w-6 h-6" />
          </button>
        )}
      </header>

      <div className="flex-1 min-h-0 overflow-y-auto p-3 space-y-2">
        {vazio ? (
          <div className="h-full flex flex-col items-center justify-center text-center text-zinc-500 gap-2 px-6">
            <ScanBarcode className="w-10 h-10" />
            <p className="text-sm">Toque num produto ou bipe o código de barras</p>
          </div>
        ) : (<>
          <AvisoOfertasCliente ofertasDia={ofertasCliente} cart={cart} className="text-zinc-100" />
          {cart.map((item) => <ItemCarrinho key={item.cartItemId || item.id} item={item} ctx={ctx} />)}
        </>)}
      </div>
      <SugestoesLateral ctx={ctx} />

      <footer className="shrink-0 p-4 border-t border-zinc-800 space-y-3">
        {/* Desconto ou cupom (30/09/2026): vale no pagamento e vai junto para a Entrega. */}
        <DescontoCarrinho ctx={ctx} />
        {montante > 0 && (
          <div className="flex justify-between text-sm text-zinc-400" data-e2e="carrinho-subtotal">
            <span>Subtotal</span><span>R$ {fmt(cartTotal)}</span>
          </div>
        )}
        <div className="flex justify-between items-baseline">
          <span className="text-zinc-400">Total</span>
          <span className="text-2xl font-black text-orange-500" data-e2e="carrinho-total">R$ {fmt(Math.max(0, cartTotal - montante))}</span>
        </div>
        <button type="button" disabled={vazio} onClick={() => setScreen("delivery_type")} data-e2e="carrinho-finalizar"
          className="w-full h-12 rounded-xl bg-orange-500 hover:bg-orange-600 disabled:opacity-40 disabled:hover:bg-orange-500 text-white font-bold text-lg transition-all active:scale-95 flex items-center justify-center gap-2">
          Finalizar <TeclaAtalho>Enter</TeclaAtalho>
        </button>
      </footer>
    </aside>
  );
}
